<template>
  <VContainer fluid>
    <div class="d-none d-lg-block ma-16 pa-16" v-html="$t('termos')"></div>
    <div class="d-lg-none" v-html="$t('termos')"></div>
  </VContainer>
</template>

<script>
export default {
  name: 'Terms',
  mounted() {
    if (this.$route?.params?.lang) {
      this.$i18n.locale = this.$route.params.lang
    }
  }
}
</script>
